/*
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from './index.js'; // import the store
vue.use(vuex);

let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
let env = global[global.env]; // define the env variable

const reporte = new vapi({
  namespace: 'reporte',
  baseURL: `${env.path.rest}/api/avance`,
  state: {
    indicadores: []
  }
}).get({
  action: "reporteavances",
  path: function (obj) {
    return `/reporteavances`
  },
  onSuccess: (state, payload ) => {
    state.indicadores = payload.data;
  }
}).getStore();

export default reporte;

*/

let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global
let env = global[global.env]

//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

//store
const reporte = new vapi({
    baseURL: `${env.path.rest}/api/avance`,
    state: {
        Aindicadores: []
    }
}).get({
    action: "ReporteAvances",
    path: function () {
        //alert("entro");
        

        if (localStorage.usuario !== undefined) {
         // alert(localStorage.usuario);
      }


        return `/reporteavances`
    },
    onSuccess: (state, payload) => {
        //alert(payload.data);        
        state.Aindicadores = payload.data;
    }
}).getStore();

reporte.getters = {
    greporteavances: state => {
        //alert(state.Aindicadores);
        return state.Aindicadores;
    }
}

export default reporte;